import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BasketCarryOverService } from './basket-carry-over.service';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [BasketCarryOverService]
})
export class BasketCarryOverModule {
    constructor(private basketCarryOverService: BasketCarryOverService) {}
}
